<template>
  <transition
    name="fade-slide"
    appear
    @beforeEnter="$emit('opening')"
    @afterEnter="$emit('opened')"
    @beforeLeave="$emit('closing')"
    @afterLeave="$emit('closed')"
  >
    <dialog
      v-if="isOpen"
      ref="drawer"
      class="drawer-backdrop"
      :class="[position]"
      open
      @click.self="onClickBackdrop"
    >
      <div
        class="drawer"
        :style="{
          maxHeight,
        }"
      >
        <slot />
      </div>
    </dialog>
  </transition>
</template>

<script>
export default {
  name: 'AppDrawer',
  inheritAttrs: false,

  data() {
    return {
      isOpen: ['', true].includes(this.$attrs.open),
      closeOnBackHook: undefined,
    }
  },

  props: {
    position: {
      type: String,
      required: false,
      default: 'bottom',
      validator: value => ['left', 'right', 'top', 'bottom'].includes(value),
    },

    closeOnBackdropClick: {
      type: [Function, Boolean],
      required: false,
      default: true,
    },

    closeOnBack: {
      type: Boolean,
      default: true,
    },

    maxHeight: {
      type: String,
      required: false,
    },
  },

  watch: {
    closeOnBack: {
      immediate: true,
      handler: 'addCloseOnBackHook',
    },
  },

  beforeUnmount() {
    this.removeCloseOnBackHook()

    document.body.classList.remove('overflow-hidden')
  },

  // created() {
  //   this.$on('opening', () => {
  //     document.body.classList.add('overflow-hidden')
  //   })

  //   this.$on('closing', () => {
  //     document.body.classList.remove('overflow-hidden')
  //   })
  // },

  methods: {
    removeCloseOnBackHook() {
      if (typeof this.closeOnBackHook === 'function') this.closeOnBackHook()

      this.closeOnBackHook = undefined
    },

    addCloseOnBackHook() {
      this.removeCloseOnBackHook()

      if (!this.closeOnBack) return

      this.closeOnBackHook = this.$router.beforeEach((to, from, next) => {
        if (this.isOpen) {
          this.close()

          if (!app.isGoToScreen) {
            next(false)
            return
          }
        }

        next()
      })
    },

    async onClickBackdrop() {
      const { closeOnBackdropClick } = this

      if (closeOnBackdropClick === true) return this.close()
      else if (typeof closeOnBackdropClick === 'function') {
        const closeOnBackdropClickResult = await closeOnBackdropClick()

        if (closeOnBackdropClickResult !== false) return this.close()
      }
    },

    show() {
      return this.open(...arguments)
    },

    async open() {
      if (this.isOpen === true) return

      return new Promise(resolve => {
        this.$once('opened', resolve)

        this.isOpen = true
      })
    },

    hide() {
      return this.close(...arguments)
    },

    close() {
      if (this.isOpen === false) return

      return new Promise(resolve => {
        this.$once('closed', resolve)

        this.isOpen = false
      })
    },

    toggle() {
      this.isOpen = !this.isOpen
    },
  },
}
</script>

<style lang="scss" scoped>
.drawer-backdrop {
  $borderRadius: 2rem;
  position: fixed;
  z-index: 10;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: currentColor;
  will-change: opacity;
  // overflow: auto;
  display: flex;

  > .drawer {
    $borderRadius: 2rem;
    // position: absolute;
    max-width: 100vw;
    // height: 100%;
    // max-height: 100%;
    background-color: #fff;
    will-change: transform;
    overflow: auto;
  }

  &.left,
  &.right {
    flex-direction: row;

    > .drawer {
      width: 390px;
      height: 100%;
    }
  }

  &.left {
    justify-content: flex-start;
    padding-right: 3rem;

    > .drawer {
      left: 0;
      border-top-right-radius: $borderRadius;
      border-bottom-right-radius: $borderRadius;
    }
  }

  &.right {
    justify-content: flex-end;
    padding-left: 3rem;

    > .drawer {
      right: 0;
      border-top-left-radius: $borderRadius;
      border-bottom-left-radius: $borderRadius;
    }
  }

  &.top,
  &.bottom {
    flex-direction: column;

    > .drawer {
      width: 100%;
      // max-height: calc(100% - 3rem);
    }
  }

  &.top {
    justify-content: flex-start;
    padding-bottom: 3rem;

    > .drawer {
      top: 0;
      border-bottom-left-radius: $borderRadius;
      border-bottom-right-radius: $borderRadius;
    }
  }

  &.bottom {
    justify-content: flex-end;
    padding-top: 3rem;

    > .drawer {
      // margin-top: 3rem;
      bottom: 0;
      border-top-left-radius: $borderRadius;
      border-top-right-radius: $borderRadius;
    }
  }
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.3s ease;

  > .drawer {
    transition: transform 0.3s ease;
  }
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;

  &.left {
    > .drawer {
      transform: translateX(-100%);
    }
  }

  &.right {
    > .drawer {
      transform: translateX(100%);
    }
  }

  &.top {
    > .drawer {
      transform: translateY(-100%);
    }
  }

  &.bottom {
    > .drawer {
      transform: translateY(100%);
    }
  }
}
</style>
